import { apiClient } from '../client';
import type { NewsItem, UserNewsReadRequest } from '@/types/api';

// /usernews — endpoint для непрочитанных новостей (UserNews-based трекинг,
// см. UsernewsController + UserNewsManager на беке):
// - GET /usernews → массив всех непрочитанных News этого юзера. Возвращает
//   News-модель через UserNewsManager::unread() — shape совпадает с NewsItem
//   из /site/news (id/title/content/time/type_id).
// - POST /usernews/read body {news_ids: [...]} → отмечает указанные id как
//   прочитанные в таблице user_news. Возвращает boolean.
//
// Это отличается от /site/news (публичный список с пагинацией pageSize=5
// + неявный bump last_read_news), используется именно для NewsModal-флоу.

export const userNewsApi = {
  list: () => apiClient.get<NewsItem[]>('/usernews').then((r) => r.data),

  read: (payload: UserNewsReadRequest) =>
    apiClient.post<boolean>('/usernews/read', payload).then((r) => r.data),
};
